<script setup lang="ts">
import {DecimalInput, DecimalInputValue} from "@hantera/design-system";
import {ref, watch} from "vue";
import Decimal from "decimal.js";

const props = defineProps<{
  modelValue: string
}>()
const emit = defineEmits< {
  (e: 'update:modelValue', value: string): void
}>()

let initialNumericValue = parseFloat(props.modelValue.replace('%', ''));
if (Number.isNaN(initialNumericValue)) {
  initialNumericValue = 0;
}

const internalValue = ref<DecimalInputValue>({
  value: new Decimal(initialNumericValue),
  isPercentage: props.modelValue.indexOf('%') !== -1
})

watch(internalValue, (newValue) => {
  emit('update:modelValue', internalValue.value.value.toString() + (internalValue.value.isPercentage ? '%': ''));
}, {
  immediate: true
})

</script>

<template>
  <div>
    <DecimalInput
      v-model="internalValue"
      class="input"
      :allow-percentage="true"
    />
  </div>
</template>

<style scoped>
:deep(.input) { text-align: left !important; }
</style>